import type { ReactNode } from 'react';

export const symbol_voicemail_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M644-367q47.08 0 80.04-32.94 32.96-32.94 32.96-80T724.06-560q-32.94-33-80-33t-79.56 32.96Q532-527.08 532-480q0 14 3 27.5t10 25.5H414q7-12 10-25.5t3-27.5q0-47.08-32.74-80.04Q361.53-593 314.76-593q-46.76 0-79.26 32.94-32.5 32.94-32.5 80T235.67-400q32.66 33 79.33 33h329Zm-366.07-75.5Q263-458 263-480t14.93-37.5q14.93-15.5 37-15.5t37.57 15.5Q368-502 368-480t-15.5 37.5Q337-427 314.93-427t-37-15.5Zm329 0Q592-458 592-480t14.93-37.5q14.93-15.5 37-15.5t37.57 15.5Q697-502 697-480t-15.5 37.5Q666-427 643.93-427t-37-15.5ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
